@if (properties() | keyvalue) {
  <h2>{{ title() }}</h2>
  <!-- <pre>{{ data() | json }}</pre> -->
  <mat-list>
    @for (p of properties() | keyvalue; track p.key) {
      <!-- metaInfo is used in origin und should be skipped -->
      @if (p.key !== 'metaInfo') {
        <mat-list-item>
          <mat-icon matListItemIcon>{{ icon(p.key) }}</mat-icon>
          <span matListItemTitle>{{ p.key }}</span>
          <span matListItemLine>
            @let mof = mofItem(p.value);
            @if (mof) {
              @switch (p.key) {
                @case ('wikiDataURL') {
                  <a href="{{ mof.value }}" target="_blank">
                    {{ mofValue(mof) }}
                  </a>
                  <mat-icon>open_in_new</mat-icon>
                }
                @default {
                  <span>{{ mofValue(mof) }}</span>
                }
              }
            } @else if (p.key.slice(-3) === 'URL') {
              <a href="{{ p.value }}" target="_blank">
                {{ p.value }}
              </a>
            } @else {
              <span>{{ p.value }}</span>
            }
          </span>
        </mat-list-item>
      }
    }
  </mat-list>
}
